import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../authContext';

export default function ManagerLayout({ children }) {
  const { authData, signOut } = useAuth();
  const user = authData.user;
  const logout = () => { signOut(); window.location.href = '/signin'; };
  return <div className="min-h-screen bg-base-200 text-base-content">
    <header className="border-b border-base-300 bg-base-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-wrap items-center justify-between gap-4">
        <div><img src="/images/bsr-logo.png" alt="BackStageRate" className="w-36" /><p className="text-sm text-base-content/60 mt-2">{user.companyName}</p></div>
        <nav aria-label="Navigation manager" className="flex flex-wrap items-center gap-2 sm:gap-4 text-sm">
          <NavLink to="/manager/results" className={({ isActive }) => isActive ? 'font-medium text-bsrate' : 'hover:text-bsrate'}>Résultats de mon équipe</NavLink>
          <NavLink to="/settings/account" className={({ isActive }) => isActive ? 'font-medium text-bsrate' : 'hover:text-bsrate'}>Mon compte</NavLink>
          <NavLink to="/help" className={({ isActive }) => isActive ? 'font-medium text-bsrate' : 'hover:text-bsrate'}>Aide</NavLink>
          <button type="button" onClick={logout} className="btn btn-ghost btn-sm">Se déconnecter</button>
        </nav>
      </div>
    </header>
    <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">{children}</main>
  </div>;
}
